import $ from 'jquery';
import tippy from 'tippy.js';

// Needed polyfill for IE11 as it doesn't support contains method on SVG element
// Info: https://github.com/kiltjs/jqlite/issues/44
if (typeof SVGElement.prototype.contains === 'undefined') {
  SVGElement.prototype.contains = HTMLDivElement.prototype.contains;
}

const defaults = {
  options: {},
};

function MapTooltip(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.getData();
  this.init();
}

MapTooltip.prototype = {
  init() {
    const myTemplate = document.createElement('div');
    $(myTemplate).addClass('map-tooltip');
    const id = this.$element.attr('id');
    let inner = '<h6 class="map-tooltip-header">Available services:</h6>';

    $.each(this.settings.options, (key, value) => {
      const newKey = key.replace(/ /g, '_');
      if (newKey === id) {
        $.each(value.services, (k, val) => {
          inner += `<h6 class="map-tooltip-service">${val}</h6>`;
        });
      }
    });

    myTemplate.innerHTML = inner;

    tippy(this.element, {
      theme: 'lightTooltip',
      size: 'large',
      arrow: true,
      arrowSize: 'big',
      html: myTemplate,
    });
  },
  getData() {
    const mapData = document.getElementById('map-data');
    $.each($(mapData).find('tr'), (i, element) => {
      const loc = $(element).find('td').first().html();
      const serv = $(element).find('td').last();
      const getServs = $(serv).find('p');
      const servs = [];

      $.each(getServs, (j, s) => {
        const servText = $(s).text();
        servs.push(servText);
      });

      const servObj = {};
      servObj.services = servs;

      this.settings.options[loc] = servObj;
    });
  },
};

export default MapTooltip;



// WEBPACK FOOTER //
// ./MapTooltip.js